import {View} from 'MWC';
import tpl from '../templates/Slider.jsx';
import {environment} from '../../../../environment/environment';
import config from '../../../../config.json';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            slides: []
        };
        this.filterSlidesByEnvironment = this.filterSlidesByEnvironment.bind(this);
    }
    filterSlidesByEnvironment(slides) {
        if (slides) {
            if (window.location.href.includes('a-bank.com.ua')) {
                return slides.filter(slide => slide.prod === true);
            } else {
                return slides.filter(slide => slide.release === true);
            }
        }
    }

    changeFilesUrl(url) {
        if (url) {
            if (url.includes('front-assets.a-bank')) {
                return url;
            } else {
                return environment.url + url;
            }
        }
    }
}
